import type { TFunction } from 'i18next';
import { apiErrorCode, isNetworkError } from '@/services/apiClient';

/**
 * A refusal in the user's own language.
 *
 * A known business code reads as its own sentence; anything else — a code this screen has no words for, a database fault behind a 500 — reads as a plain one. The server's own text is never shown: it is English, and a fault's text is not for a customer-facing counter.
 */
export function trackingErrorMessage(t: TFunction, error: unknown): string {
  if (isNetworkError(error)) return t('opticalOrders.tracking.errors.network');
  const code = apiErrorCode(error);
  if (code) {
    const known = t(`apiErrors.${code}`, { defaultValue: '' });
    if (known) return known;
    const local = t(`opticalOrders.tracking.errors.codes.${code}`, { defaultValue: '' });
    if (local) return local;
  }
  return t('opticalOrders.tracking.errors.generic');
}
